import { createReducer, on } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { Promocode, PromocodeUsage } from '@rd/types/promocode.type';
import * as actions from '../actions/promocode.actions';

export interface PromocodeState {
  value: Promocode | null;
  usage: PromocodeUsage | null;
  post: {
    error: HttpError | null;
    loading: boolean;
  };
}

export const initialState: PromocodeState = {
  value: null,
  usage: null,
  post: {
    error: null,
    loading: false,
  },
};

export const promocodeReducer = createReducer(
  initialState,
  on(actions.ClearPromocodeData, () => initialState),
  on(actions.ValidatePromocodeData, (state) => ({
    ...state,
    post: { error: null, loading: true },
  })),
  on(
    actions.ValidatePromocodeDataSuccess,
    (_, { promocode, promocodeUsage }) => ({
      value: promocode,
      usage: promocodeUsage,
      post: {
        error: null,
        loading: false,
      },
    }),
  ),
  on(actions.ValidatePromocodeDataFail, (state, { error }) => ({
    ...state,
    post: {
      error,
      loading: false,
    },
  })),
  on(actions.HydratePromocode, (state, { promocode, promocodeUsage }) => ({
    ...state,
    value: promocode,
    usage: promocodeUsage,
  })),
);
